var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cart"},[_c('div',{staticClass:"reportBasic-subTitle"},[_vm._v("\n    "+_vm._s(_vm.$tc('lang.LoadingReport.Truck_And_Container'))+"\n  ")]),_c('div',{staticClass:"desOfGoods-con"},[_c('span',[_vm._v(_vm._s(_vm.$tc('lang.LoadingReport.Truck_Front')))]),_c('div',{staticClass:"img"},[_c('show-img',{attrs:{"data":_vm.cart.lmediaTruckfront,"otherData":{
          mediaName: '货柜前面照',
          mediaType: 3,
          personId: '',
          orderId: '',
          reportId: '',
          mediaDesc: 'lmediaTruckfront',
        },"id":_vm.id}})],1)]),_c('div',{staticClass:"desOfGoods-con"},[_c('span',[_vm._v(_vm._s(_vm.$tc('lang.LoadingReport.Licence')))]),_c('div',{staticClass:"img"},[_c('show-img',{attrs:{"data":_vm.cart.lmediaLicence,"otherData":{
          mediaName: '车牌',
          mediaType: 3,
          personId: '',
          orderId: '',
          reportId: '',
          mediaDesc: 'lmediaLicence',
        },"id":_vm.id}})],1)]),_c('div',{staticClass:"desOfGoods-con"},[_c('span',[_vm._v(_vm._s(_vm.$tc('lang.LoadingReport.Container_Side')))]),_c('div',{staticClass:"img"},[_c('show-img',{attrs:{"data":_vm.cart.lmediaContainerside,"otherData":{
          mediaName: '货柜侧面',
          mediaType: 3,
          personId: '',
          orderId: '',
          reportId: '',
          mediaDesc: 'lmediaContainerside',
        },"id":_vm.id}})],1)]),_c('div',{staticClass:"desOfGoods-con"},[_c('span',[_vm._v(_vm._s(_vm.$tc('lang.LoadingReport.Container_Inside_Check')))]),_c('div',{staticClass:"img"},[_c('show-img',{attrs:{"data":_vm.cart.lmediaCheck,"otherData":{
          mediaName: '货柜前柜内检查',
          mediaType: 3,
          personId: '',
          orderId: '',
          reportId: '',
          mediaDesc: 'lmediaCheck',
        },"id":_vm.id}})],1)]),_c('div',{staticClass:"desOfGoods-con"},[_c('span',[_vm._v(_vm._s(_vm.$tc('lang.LoadingReport.Container_No_Inside')))]),_c('div',{staticClass:"img"},[_c('show-img',{attrs:{"data":_vm.cart.lmediaContinside,"otherData":{
          mediaName: '货柜内壁柜号',
          mediaType: 3,
          personId: '',
          orderId: '',
          reportId: '',
          mediaDesc: 'lmediaContinside',
        },"id":_vm.id}})],1)]),_c('div',{staticClass:"desOfGoods-con"},[_c('span',[_vm._v(_vm._s(_vm.$tc('lang.LoadingReport.Container_No_Outside')))]),_c('div',{staticClass:"img"},[_c('show-img',{attrs:{"data":_vm.cart.lmediaContoutside,"otherData":{
          mediaName: '货柜外壁柜号',
          mediaType: 3,
          personId: '',
          orderId: '',
          reportId: '',
          mediaDesc: 'lmediaContoutside',
        },"id":_vm.id}})],1)]),_c('div',{staticClass:"desOfGoods-con"},[_c('span',[_vm._v(_vm._s(_vm.$tc('lang.LoadingReport.Truck_Badge_Back')))]),_c('div',{staticClass:"img"},[_c('show-img',{attrs:{"data":_vm.cart.lmediaBadgeback,"otherData":{
          mediaName: '货柜车尾照',
          mediaType: 3,
          personId: '',
          orderId: '',
          reportId: '',
          mediaDesc: 'lmediaBadgeback',
        },"id":_vm.id}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }